import React from 'react';
import { AsyncTypeahead } from '../AsyncTypeahead/AsyncTypeahead';
import './CaseSearch.scss';
import { TypeaheadProps } from 'components/Typeahead/Typeahead';

export interface CaseSearchResult {
    caseId: number;
    caseNumber: string;
    caseCaption?: string;
    caseCategoryName?: string;
    isCaseClosed: boolean;
}

export interface CaseSearchProps extends TypeaheadProps<any> {
    
    id: string;
    name: string;
    onSearch: any;
    options: any[];
    label?: string;
    placeholder?: string;
}

/**
 * Provides a default label and menu rendering for AsyncTypeahead.
 * Assumes you will use CaseSearchResult as your base data type.
 * @param props 
 */
export const CaseSearch: React.FC<CaseSearchProps> = (props) => {
    
    return (
        <AsyncTypeahead 
            id={props.id}
            name={props.name}
            label="Search for Additional Cases" 
            placeholder="Type to search for cases"
            onSearch={props.onSearch} 
            options={props.options} 
            onChange={props.onChange} 
            getOptionLabel={(o: CaseSearchResult) => o.caseNumber}
            renderMenuItemChildren={(option: CaseSearchResult, metadata: any) => (
                <div>
                    <div><strong>{option.caseNumber}{option.isCaseClosed ? ' [CLOSED]' : ''}</strong></div>
                    <div><em>{option.caseCaption}</em></div>
                </div>
            )}
            {...props}
        />
    )
}

(CaseSearch as any).displayName = "CaseSearch";